/* ============================================================================
   PARTAGER — la píldora que se abre
   ----------------------------------------------------------------------------
   Mismo mecanismo que el resto: el control no se sustituye, se transforma. La
   píldora « Partager » se queda en su sitio y su CONTENIDO cambia. No sale un
   menú de ninguna parte, porque un menú que aparece obliga a buscar de dónde
   vino.

   DESTINOS REALES, y sólo eso. La referencia enseña WhatsApp, X, Instagram y
   GitHub; EDISAMP no tiene perfiles confirmados en ninguno, así que poner sus
   iconos sería inventar cuentas. Aquí hay dos cosas y las dos existen:

     · el compartir NATIVO del teléfono (Web Share API), que abre las apps que
       el cliente tiene de verdad instaladas — mejor que cualquier lista que
       nosotros adivinemos
     · copiar el enlace, que funciona en todas partes

   Cuando haya perfiles confirmados se añaden aquí, y sólo aquí.
   ========================================================================== */

const PARTAGER = (() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);

  /* `navigator.share` existe en escritorio pero suele fallar o no ofrecer
     nada útil. Se pregunta también por el puntero: en un teléfono el menú
     nativo es la mejor respuesta; en un ordenador, copiar el enlace lo es. */
  const hayNativo = () => typeof navigator.share === 'function'
    && matchMedia('(pointer: coarse)').matches;

  function montar(boton, datos) {
    if (!boton || boton.dataset.partagerMontado) return;
    boton.dataset.partagerMontado = 'true';

    const original = boton.innerHTML;
    let abierto = false;

    const cerrar = () => {
      if (!abierto) return;
      abierto = false;
      boton.innerHTML = original;
      boton.removeAttribute('data-abierto');
      boton.setAttribute('aria-expanded', 'false');
    };

    async function copiar() {
      const url = datos.url || location.href;
      try {
        await navigator.clipboard.writeText(url);
        return true;
      } catch (e) {
        /* Sin permiso de portapapeles —o sin HTTPS— queda el camino viejo,
           que sigue funcionando en todos los navegadores. */
        const t = document.createElement('textarea');
        t.value = url;
        t.style.cssText = 'position:fixed;opacity:0';
        document.body.append(t);
        t.select();
        let ok = false;
        try { ok = document.execCommand('copy'); } catch (e2) { ok = false; }
        t.remove();
        return ok;
      }
    }

    function abrir() {
      abierto = true;
      boton.dataset.abierto = 'true';
      boton.setAttribute('aria-expanded', 'true');
      boton.innerHTML =
        '<span class="partager__ops">'
        + '<span class="partager__op" data-op="copier">'
        + '<svg viewBox="0 0 20 20" aria-hidden="true"><rect x="7" y="7" width="9" height="9" rx="2"/>'
        + '<path d="M13 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/></svg>'
        + '<span>Copier le lien</span></span></span>';

      $('.partager__op[data-op="copier"]', boton).addEventListener('click', async (e) => {
        e.stopPropagation();
        const ok = await copiar();
        boton.innerHTML = '<span class="partager__ops"><span class="partager__op" data-fait="'
          + (ok ? 'si' : 'no') + '">'
          + (ok ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4.5 10.5l3.6 3.6 7.4-8.2"/></svg>'
                  + '<span>Lien copié</span>'
                : '<span>' + (datos.url || location.href) + '</span>')
          + '</span></span>';
        if (ok) setTimeout(cerrar, 1400);
      });
    }

    boton.addEventListener('click', async (e) => {
      if (e.target.closest('.partager__op')) return;

      if (hayNativo()) {
        /* En el teléfono no se inventa una lista: se abre la del sistema, que
           tiene las apps que el cliente USA. */
        try {
          await navigator.share({
            title: datos.title || document.title,
            text: datos.text || '',
            url: datos.url || location.href,
          });
        } catch (err) { /* cancelar no es un error */ }
        return;
      }

      if (abierto) cerrar(); else abrir();
    });

    document.addEventListener('click', (e) => {
      if (abierto && !boton.contains(e.target)) cerrar();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') cerrar(); });
  }

  return { montar, hayNativo };
})();

if (typeof window !== 'undefined') window.PARTAGER = PARTAGER;
